import type { ClientSuggestionCategory } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { RadioButton } from 'react-native-paper';

import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    listSection: { backgroundColor: theme.colors.surfaceContainerLow },
    marketTypeSegmentedButton: {
      marginTop: 20,
      width: 210,
      alignSelf: 'center'
    }
  });

type SuggestionCategorySelectionProps = {
  selected?: ClientSuggestionCategory;
  suggestionCategories: ClientSuggestionCategory[];
  onSelect: (value: ClientSuggestionCategory) => void;
};

export const SuggestionCategorySelection: FC<
  SuggestionCategorySelectionProps
> = ({ selected, suggestionCategories, onSelect }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <ListSection style={styles.listSection}>
      {suggestionCategories?.map((category) => (
        <ListItem
          key={category.id}
          title={category.displayName}
          onPress={() => onSelect(category)}
          arrowIcon={() => (
            <View style={{ margin: -8 }}>
              <RadioButton
                onPress={() => onSelect(category)}
                value={category.id}
                status={selected?.id === category.id ? 'checked' : 'unchecked'}
              />
            </View>
          )}
        />
      ))}
    </ListSection>
  );
};
